module.exports = __webpack_public_path__ + "348e9ad84cf0ed2bb9a57fed2902a69e.png";